import { getlist, post } from "../../contexts/apicontexts";
import config from "../../config";

const BASE = `${config.baseurl}DepartmentTaskAnalytics`;

const n = (v, fallback = 0) => { const p = Number(v); return Number.isFinite(p) ? p : fallback; };
const s = (v, fallback = "") => (typeof v === "string" ? v : typeof v === "number" ? String(v) : fallback);

function normalizeSummary(raw) {
  const r = raw ?? {};
  return {
    totalTasks:             n(r.totalTasks             ?? r.TotalTasks),
    completedTasks:         n(r.completedTasks         ?? r.CompletedTasks),
    pendingTasks:           n(r.pendingTasks           ?? r.PendingTasks),
    inProgressTasks:        n(r.inProgressTasks        ?? r.InProgressTasks),
    cancelledTasks:         n(r.cancelledTasks         ?? r.CancelledTasks),
    completionRate:         n(r.completionRate         ?? r.CompletionRate),
    highestDepartment:      s(r.highestDepartment      ?? r.HighestDepartment),
    highestDepartmentCount: n(r.highestDepartmentCount ?? r.HighestDepartmentCount),
    lowestDepartment:       s(r.lowestDepartment       ?? r.LowestDepartment),
    lowestDepartmentCount:  n(r.lowestDepartmentCount  ?? r.LowestDepartmentCount),
    totalDepartments:       n(r.totalDepartments       ?? r.TotalDepartments),
  };
}

function normalizeDeptStat(raw) {
  const r = raw ?? {};
  return {
    departmentId:   n(r.departmentId   ?? r.DepartmentId),
    departmentName: s(r.departmentName ?? r.DepartmentName),
    departmentCode: s(r.departmentCode ?? r.DepartmentCode),
    total:          n(r.total          ?? r.Total),
    completed:      n(r.completed      ?? r.Completed),
    pending:        n(r.pending        ?? r.Pending),
    inProgress:     n(r.inProgress     ?? r.InProgress),
    cancelled:      n(r.cancelled      ?? r.Cancelled),
    waiting:        n(r.waiting        ?? r.Waiting),
    completionRate: n(r.completionRate ?? r.CompletionRate),
  };
}

function normalizeMonthlyTrend(raw) {
  const r = raw ?? {};
  return {
    year:       n(r.year       ?? r.Year),
    month:      n(r.month      ?? r.Month),
    monthLabel: s(r.monthLabel ?? r.MonthLabel),
    departments: Array.isArray(r.departments ?? r.Departments)
      ? (r.departments ?? r.Departments).map(d => ({
          departmentName: s(d.departmentName ?? d.DepartmentName),
          total:          n(d.total          ?? d.Total),
          completed:      n(d.completed      ?? d.Completed),
        }))
      : [],
  };
}

export function buildDepartmentTaskAnalyticsPayload(filters) {
  const payload = {};

  if (filters.mode === "custom") {
    if (filters.startDate) payload.StartDate = filters.startDate;
    if (filters.endDate)   payload.EndDate   = filters.endDate;
  } else {
    if (filters.year) payload.Year = Number(filters.year);
    if (filters.mode === "month" && filters.month) payload.Month = Number(filters.month);
  }

  if (filters.departmentId) payload.DepartmentId = Number(filters.departmentId);
  return payload;
}

export async function fetchDepartmentTaskAnalytics(filters) {
  const payload = buildDepartmentTaskAnalyticsPayload(filters);
  const res = await post(`${BASE}/report`, payload);
  if (res?.status !== 200) throw new Error("Department task analytics could not be loaded.");
  const data = res.data ?? {};
  return {
    summary:        normalizeSummary(data.summary ?? data.Summary),
    departmentStats: Array.isArray(data.departmentStats ?? data.DepartmentStats)
      ? (data.departmentStats ?? data.DepartmentStats).map(normalizeDeptStat)
      : [],
    monthlyTrend: Array.isArray(data.monthlyTrend ?? data.MonthlyTrend)
      ? (data.monthlyTrend ?? data.MonthlyTrend).map(normalizeMonthlyTrend)
      : [],
  };
}

export async function fetchDepartmentsForFilter() {
  try {
    const res = await getlist(`${config.baseurl}Departments/getlist`);
    if (res?.status !== 200) return [];
    const list = Array.isArray(res.data) ? res.data : [];
    return list.map(d => ({
      id:   n(d.id   ?? d.Id),
      name: s(d.name ?? d.Name),
      code: s(d.code ?? d.Code),
    }));
  } catch {
    return [];
  }
}

export function getDefaultDeptTaskFilters() {
  const now = new Date();
  return {
    year:         String(now.getFullYear()),
    month:        "",
    startDate:    null,
    endDate:      null,
    departmentId: "",
    mode:         "year", // "year" | "month" | "custom"
  };
}
